import { useProductsStore } from '@/stores/products'

export function imageUrl(image, queryString) {
  const store = useProductsStore();
  if (typeof image !== 'object' || image === null) return;

  if (typeof queryString === 'object' && queryString !== null) {
    let qs = '';
    if (queryString.width) {
      qs += `w=${queryString.width}&`;
    }
    if (queryString.height) {
      qs += `h=${queryString.height}&`;
    }
    if (queryString.autocrop) {
      qs += 'zs=1';
    }
    queryString = qs;
  }

  const url = `${store.domain.url}/image/${encodeURIComponent(image.id)}/${encodeURIComponent(image.name)}${queryString ? '?' + queryString : ''}`;
  const testUrl = `${image.url}${queryString ? '?' + queryString : ''}`
  // return url

  // if(image.id === '842317') {
  //   console.log({ url })
  //   console.log({ imageUrl: image.url })
  //   console.log({ testUrl })
  // }

  return url;
}
